import { ConfirmRatePlanHighlights } from "@Light/components/enroll/ConfirmRate/ConfirmRatePlanHighlights";
import { useScaffold } from "@Light/scaffold";
import { formatBrandedPlanName } from "@Light/utils/formatting";
import { usePlan } from "@Light/utils/plan";
import clsx from "clsx";

export type WaitingForServiceProps = {};

export const WaitingForService: React.FC<WaitingForServiceProps> = ({}) => {
  const plan = usePlan();
  const scaffold = useScaffold();
  const PageBody = scaffold.page.pageBody;
  return (
    <PageBody>
      <div className="flex flex-col gap-6 pt-8">
        <div className={clsx("font-medium", scaffold.page.colors.text.primary)}>
          We're waiting for your service to start with the{" "}
          {formatBrandedPlanName(scaffold.page, plan.group.name)}
        </div>
        <div
          className={clsx(
            "flex flex-col gap-4",
            "text-xs",
            scaffold.page.colors.text.tertiary,
          )}
        >
          <ConfirmRatePlanHighlights label="You’re on your way to having" />
          <div className="text-sm">
            You'll receive an email confirmation once your service is up and
            running. No need to reach out to your old provider.
          </div>
        </div>
      </div>
    </PageBody>
  );
};
